/**
 * Store pages are always akt page numbers.
 * Viewer-local 1..N is remapped at the viewer boundary before a command is dispatched.
 * Empty means none. Whole-document digital rows use extent "entire_akt".
 */
import {
   normalizePages,
   resolvePagesToPersistOnViewerClose,
   viewerCloseKeepsPageApproval,
   type PdfSourceKind,
} from "src/modules/ANNModule/ANNServitutDocumentAnnotations";
import { areServitutPagesEqual } from "src/modules/ANNModule/ANNServitutProvenance";

export type PageExtent = "missing" | "entire_akt" | "selection";

export type PageModel = {
   selected: number[];
   aiSuggested: number[];
   extent: PageExtent;
};

export function emptyPageModel(): PageModel {
   return { selected: [], aiSuggested: [], extent: "missing" };
}

export function normalizeAktPages(pages: number[] | undefined): number[] {
   return normalizePages(pages || []);
}

export function aktPagesEqual(a: number[] | undefined, b: number[] | undefined): boolean {
   return areServitutPagesEqual(a || [], b || []);
}

export function pageModelFromLists(
   selected: number[] | undefined,
   aiSuggested: number[] | undefined,
   extent: PageExtent = "selection",
): PageModel {
   return {
      selected: normalizeAktPages(selected),
      aiSuggested: normalizeAktPages(aiSuggested),
      extent,
   };
}

export function resolveExtent(
   selected: number[],
   options?: { digitalEntireAkt?: boolean },
): PageExtent {
   if (options?.digitalEntireAkt) {
      return "entire_akt";
   }
   if (!selected.length) {
      return "missing";
   }
   return "selection";
}

export function aktPagesFromViewerClose(params: {
   pdfSourceKind?: PdfSourceKind;
   selectedViewerPages: number[];
   sourceExtractedPages?: number[];
   numPages: number;
   treatEmptyPagesKeptAsAll?: boolean;
}): number[] {
   return resolvePagesToPersistOnViewerClose(params);
}

export function viewerCloseIsNoop(
   previousSelected: number[] | undefined,
   persistedAktPages: number[],
): boolean {
   return viewerCloseKeepsPageApproval(previousSelected, persistedAktPages);
}

export { normalizePages };
